import React from 'react'

const DetailsHeading = ({title}) => {
  return (
    <div className = "w-screen text-center text-2xl font-semibold">{title}</div>
  )
}

export default DetailsHeading